import React from 'react'
import { SkeletonCell } from '../../components/SkeletonCell'

const PermissionSetSkeletol = () => {
  return (
    <div>
        <div className="d-flex gap-3 align-items-center justify-content-between">
            <SkeletonCell style={{ width: "300px", height: "16px" }} />
            {/* <div className="col-5 d-flex gap-2 justify-content-end">
                <SkeletonCell style={{ width: "160px", height: "40px" }} />
                <SkeletonCell style={{ width: "90px", height: "40px" }} />
            </div> */}
        </div>
        <div className="all-permissions">
            {[...Array(4)].map((_, j) => (
                <div className="the-permission" key={j}>
                    <SkeletonCell style={{ width: "200px", height: "19px" }} className='my-4' />
                    <div className='container'>
                    <div className="row row-cols-3">
                        {[...Array(4)].map((_, i) => (
                        <div className="col mb-3 d-flex p-0 pe-3" key={i}>
                            <SkeletonCell style={{ width: "20px", height: "20px" }} className='me-2' />
                            <SkeletonCell style={{ width: "280px", height: "20px" }} />
                        </div>
                        ))}
                    </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
  )
}

export default PermissionSetSkeletol